<template lang="pug">
  SmartDialog(
    v-if="dialogShow"
    v-model="filterVisible"
    :title="dialogLabel")
    SmartForm(
      labelPosition="right"
      btnPosition="center"
      :btnLabel="false"
      :isWidthAll="true"
      :labelSize="4"
      :formList="formList"
      :values="dialogFormValues"
      :columns="columns"
      :buttonList="dialogButtonList"
      :formEnterIndex="0")
</template>
<script>
import SmartDialog from '@/components/SmartDialog'
import SmartForm from '@/components/SmartForm'
export default {
  name: 'SeniorFilter',
  components: {
    SmartDialog,
    SmartForm
  },
  props: {
    dialogVisible: Boolean,
    formList: Array,
    columns: Object
  },
  computed: {
    dialogShow () {
      return this.filterVisible
    }
  },
  watch: {
    dialogVisible (val) {
      this.filterVisible = val
    },
    filterVisible (val) {
      this.setDialogStatus()
    }
  },
  data () {
    return {
      dialogLabel: '高级搜索',
      filterVisible: this.dialogVisible,
      dialogFormValues: {},
      dialogButtonList: [{
        label: '搜索',
        icon: 'search',
        type: 'success',
        validate: true,
        funcProps: {
          el: this
        },
        func: ({funcProps}) => {
          const { formValues } = funcProps.form
          this.filterVisible = false
          this.renderValues(formValues)
        }
      }, {
        name: 'reset',
        label: '清空',
        func: ({funcProps}) => {
          const { formValues } = funcProps.form
          Object.keys(formValues).map(key => {
            formValues[key] = null
            delete formValues[key]
          })
          this.renderValues([])
        }
      }]
    }
  },
  methods: {
    setDialogStatus () {
      if (!this.filterVisible) {
        this.dialogFormValues = {}
      }
      this.$emit('dialogVisiStatus', this.filterVisible)
    },
    renderValues (value) {
      this.$emit('getFormValues', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SeniorFilter.vue?7a4a7d3f